// components/TopBar.js
import React, { useState } from 'react';
import {
  AiOutlineSync, AiOutlineGlobal
} from 'react-icons/ai';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTelegram } from '@fortawesome/free-brands-svg-icons';
import { t } from 'ttag';
import './css/TopBar.css'; // Импортируем файл стилей
import './css/LanguageSwitcher.css'; // Додамо стиль для перемикача мов (створимо його пізніше)
import uk from '../i18n/uk.png';
import en from '../i18n/en.png';
import ru from '../i18n/ru.png';
import es from '../i18n/es.png';
import de from '../i18n/de.png';
import fr from '../i18n/fr.png';
import it from '../i18n/it.png';
import pl from '../i18n/pl.png';
import zh from '../i18n/zh.png';
import vi from '../i18n/vi.png';
import id from '../i18n/id.png';
import th from '../i18n/th.png';
import hi from '../i18n/hi.png';
import ar from '../i18n/ar.png';
import tr from '../i18n/tr.png';
import { mixpanel } from './mp.js';

function TopBar({ handlesetIndex, index, setIsAuthorized, setlocale }) {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isLanguageMenuOpen, setIsLanguageMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const toggleMenuAct = (ind) => {
    if (index === 0) { mixpanel.track('topMenu-Home') }
    if (index === 1) { mixpanel.track('topMenu-Earn') }
    if (index === 2) { mixpanel.track('topMenu-Affiliate') }
    if (index === 3) { mixpanel.track('topMenu-Project') }
    if (index === 6) { mixpanel.track('topMenu-Card') }

    handlesetIndex(ind);
    setIsMenuOpen(!isMenuOpen);
  };
  const toggleMenuActUpd = () => {
    handlesetIndex(0);
    setIsAuthorized(false);
    setIsMenuOpen(!isMenuOpen);
  };

  const toggleLanguageMenu = () => {
    setIsLanguageMenuOpen(!isLanguageMenuOpen);
  };

  const changeLanguage = (lang) => {
    mixpanel.track('topMenu-changeLanguage-to-' + lang)
    localStorage.setItem("lng", lang)
    setlocale(lang);
    setIsLanguageMenuOpen(false);
  };
  return (
    <div className="top-bar">
      <div>
        <div className="top-bar-title">BitBook</div>
        <div className="top-bar-subtitle">{t`Equity Holder Dashboard`}</div>
      </div>
      <div style={{ display: "flex", alignItems: "center" }}>
        <button style={{ display: "flex" }} className="menu-button" onClick={() => { toggleMenuActUpd(); }} >
          <AiOutlineSync />
        </button>
        <a className="menu-button"
          href="https://t.me/bitbook_channel_en"
          target="_blank"
          rel="noopener noreferrer"
          style={{ height: "100%", fontSize: "2em", border: "none" }}
          onClick={() => mixpanel.track('topMenu-to-telegram-chanel')}
        >

          <FontAwesomeIcon icon={faTelegram} />
        </a>

        <div className="language-switcher">
          <button className="language-button" onClick={toggleLanguageMenu}>
            <AiOutlineGlobal /> {/* Або можна використати іконку прапора за замовчуванням */}
          </button>
          {isLanguageMenuOpen && (

            <div className="language-dropdown">
              <div >
                <button className="language-option" onClick={() => changeLanguage('en')}><img src={en} /> English</button>
                <button className="language-option" onClick={() => changeLanguage('uk')}><img src={uk} /> Українська</button>
                <button className="language-option" onClick={() => changeLanguage('ru')}><img src={ru} /> Русский</button>
                <button className="language-option" onClick={() => changeLanguage('es')}><img src={es} /> Español</button>
                <button className="language-option" onClick={() => changeLanguage('de')}><img src={de} /> Deutsch</button>
                <button className="language-option" onClick={() => changeLanguage('fr')}><img src={fr} /> Français</button>
                <button className="language-option" onClick={() => changeLanguage('it')}><img src={it} /> Italiano</button>
                <button className="language-option" onClick={() => changeLanguage('pl')}><img src={pl} /> Polski</button>
              </div>
              <div>
                <button className="language-option" onClick={() => changeLanguage('zh')}><img src={zh} /> 中文 (Zhōngwén)</button>
                <button className="language-option" onClick={() => changeLanguage('vi')}><img src={vi} /> Tiếng Việt</button>
                <button className="language-option" onClick={() => changeLanguage('id')}><img src={id} /> Bahasa Indonesia</button>
                <button className="language-option" onClick={() => changeLanguage('th')}><img src={th} /> ภาษาไทย (Phasa Thai)</button>
                <button className="language-option" onClick={() => changeLanguage('hi')}><img src={hi} /> हिन्दी (Hindi)</button>
                <button className="language-option" onClick={() => changeLanguage('ar')}><img src={ar} /> العربية (Al-‘Arabīyah)</button>
                <button className="language-option" onClick={() => changeLanguage('tr')}><img src={tr} /> Türkçe</button>
              </div>
            </div>
          )}
        </div>
        <button className="menu-button" onClick={toggleMenu}>
          ☰
        </button>
        {isMenuOpen && (
          <div className="dropdown-menu">
            <a href="#" className="dropdown-item" onClick={() => { toggleMenuAct(0); }} >{t`Home`}</a>
            <a href="#" className="dropdown-item" onClick={() => { toggleMenuAct(1); }} >{t`Earn`}</a>
            <a href="#" className="dropdown-item" onClick={() => { toggleMenuAct(2); }} >{t`Affiliate`}</a>
            <a href="#" className="dropdown-item" onClick={() => { toggleMenuAct(3); }} >{t`Project`}</a>
            <a href="#" className="dropdown-item" onClick={() => { toggleMenuAct(6); }} >{t`Partners`}</a>
            <a href="https://t.me/sonat_trade_bot" className="dropdown-item"  >{t`SoNat Trade`}</a>
            <a href="#" className="dropdown-item" onClick={() => { toggleMenuActUpd(); }} >{t`Update`}</a>
          </div>
        )}

      </div>
    </div>
  );
}

export { TopBar };